import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '@/theme';
import { SubHeading, Caption } from '@/components/ui/Text';

type TripListSectionHeaderProps = {
  title: string;
  count?: number;
  icon?: keyof typeof Ionicons.glyphMap;
  sticky?: boolean;
};

export function TripListSectionHeader({
  title,
  count,
  icon = 'airplane-outline',
  sticky = false,
}: TripListSectionHeaderProps) {
  const theme = useTheme();

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing(1),
        paddingVertical: theme.spacing(1.1),
        paddingHorizontal: theme.spacing(2),
        backgroundColor: sticky ? theme.colors.background : 'transparent',
        borderBottomWidth: sticky ? 1 : 0,
        borderBottomColor: theme.colors.borderMuted,
      }}
    >
      <View
        style={{
          width: 4,
          height: 32,
          borderRadius: theme.radii.sm,
          backgroundColor: theme.colors.primary,
        }}
      />
      <View
        style={{
          width: 32,
          height: 32,
          borderRadius: theme.radii.pill,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.colors.primary + '12',
        }}
      >
        <Ionicons name={icon} size={17} color={theme.colors.primary} />
      </View>
      <SubHeading style={{ flex: 1, letterSpacing: -0.15 }}>{title}</SubHeading>
      {count !== undefined && (
        <View
          style={{
            backgroundColor: theme.colors.primary + '16',
            paddingHorizontal: theme.spacing(1),
            paddingVertical: theme.spacing(0.35),
            borderRadius: theme.radii.pill,
            minWidth: 32,
            alignItems: 'center',
          }}
        >
          <Caption color={theme.colors.primary} style={{ fontSize: 12.5, fontWeight: '800' }}>
            {count}
          </Caption>
        </View>
      )}
    </View>
  );
}

